/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PracticeBaseService } from '../practice-base-service';
import { PracticeApiConfiguration } from '../practice-api-configuration';
import { PracticeStrictHttpResponse } from '../practice-strict-http-response';

import { ClinicGroupDetailModel } from '../models/clinic-group-detail-model';
import { facilitiesGet } from '../fn/practitioner/facilities-get';
import { FacilitiesGet$Params } from '../fn/practitioner/facilities-get';
import { FacilityModel } from '../models/facility-model';
import { practitionerClinicGroupIdPractitionerIdFacilitiesGet } from '../fn/practitioner/practitioner-clinic-group-id-practitioner-id-facilities-get';
import { PractitionerClinicGroupIdPractitionerIdFacilitiesGet$Params } from '../fn/practitioner/practitioner-clinic-group-id-practitioner-id-facilities-get';
import { practitionerIdGet } from '../fn/practitioner/practitioner-id-get';
import { PractitionerIdGet$Params } from '../fn/practitioner/practitioner-id-get';
import { practitionerLinkProtocolPost } from '../fn/practitioner/practitioner-link-protocol-post';
import { PractitionerLinkProtocolPost$Params } from '../fn/practitioner/practitioner-link-protocol-post';
import { PractitionerModel } from '../models/practitioner-model';
import { practitionerPost } from '../fn/practitioner/practitioner-post';
import { PractitionerPost$Params } from '../fn/practitioner/practitioner-post';
import { practitionerPractitionerIdClinicGroupsGet } from '../fn/practitioner/practitioner-practitioner-id-clinic-groups-get';
import { PractitionerPractitionerIdClinicGroupsGet$Params } from '../fn/practitioner/practitioner-practitioner-id-clinic-groups-get';
import { practitionerRegisterPost } from '../fn/practitioner/practitioner-register-post';
import { PractitionerRegisterPost$Params } from '../fn/practitioner/practitioner-register-post';
import { practitionerRegisterPractitionerPost } from '../fn/practitioner/practitioner-register-practitioner-post';
import { PractitionerRegisterPractitionerPost$Params } from '../fn/practitioner/practitioner-register-practitioner-post';
import { practitionerRegisterWithRolesPost } from '../fn/practitioner/practitioner-register-with-roles-post';
import { PractitionerRegisterWithRolesPost$Params } from '../fn/practitioner/practitioner-register-with-roles-post';
import { practitionerUnLinkProtocolPost } from '../fn/practitioner/practitioner-un-link-protocol-post';
import { PractitionerUnLinkProtocolPost$Params } from '../fn/practitioner/practitioner-un-link-protocol-post';
import { practitionerUpdateStatusPost } from '../fn/practitioner/practitioner-update-status-post';
import { PractitionerUpdateStatusPost$Params } from '../fn/practitioner/practitioner-update-status-post';

@Injectable({ providedIn: 'root' })
export class PracticePractitionerService extends PracticeBaseService {
  constructor(config: PracticeApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `practitionerIdGet()` */
  static readonly PractitionerIdGetPath = '/Practitioner/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerIdGet$Response(params: PractitionerIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PractitionerModel>> {
    const obs = practitionerIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerIdGet(params: PractitionerIdGet$Params, context?: HttpContext): Observable<PractitionerModel> {
    const resp = this.practitionerIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<PractitionerModel>): PractitionerModel => r.body)
    );
  }

  /** Path part for operation `practitionerPost()` */
  static readonly PractitionerPostPath = '/Practitioner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerPost$Response(params?: PractitionerPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<string>> {
    const obs = practitionerPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerPost(params?: PractitionerPost$Params, context?: HttpContext): Observable<string> {
    const resp = this.practitionerPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `practitionerUpdateStatusPost()` */
  static readonly PractitionerUpdateStatusPostPath = '/Practitioner/UpdateStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerUpdateStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerUpdateStatusPost$Response(params?: PractitionerUpdateStatusPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = practitionerUpdateStatusPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerUpdateStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerUpdateStatusPost(params?: PractitionerUpdateStatusPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.practitionerUpdateStatusPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `practitionerRegisterPractitionerPost()` */
  static readonly PractitionerRegisterPractitionerPostPath = '/Practitioner/RegisterPractitioner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerRegisterPractitionerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerRegisterPractitionerPost$Response(params?: PractitionerRegisterPractitionerPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<string>> {
    const obs = practitionerRegisterPractitionerPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerRegisterPractitionerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerRegisterPractitionerPost(params?: PractitionerRegisterPractitionerPost$Params, context?: HttpContext): Observable<string> {
    const resp = this.practitionerRegisterPractitionerPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `practitionerRegisterPost()` */
  static readonly PractitionerRegisterPostPath = '/Practitioner/Register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerRegisterPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  practitionerRegisterPost$Response(params?: PractitionerRegisterPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = practitionerRegisterPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerRegisterPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   *
   * @deprecated
   */
  practitionerRegisterPost(params?: PractitionerRegisterPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.practitionerRegisterPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `practitionerRegisterWithRolesPost()` */
  static readonly PractitionerRegisterWithRolesPostPath = '/Practitioner/RegisterWithRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerRegisterWithRolesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerRegisterWithRolesPost$Response(params?: PractitionerRegisterWithRolesPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = practitionerRegisterWithRolesPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerRegisterWithRolesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerRegisterWithRolesPost(params?: PractitionerRegisterWithRolesPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.practitionerRegisterWithRolesPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `practitionerClinicGroupIdPractitionerIdFacilitiesGet()` */
  static readonly PractitionerClinicGroupIdPractitionerIdFacilitiesGetPath = '/Practitioner/{clinicGroupId}/{practitionerId}/Facilities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerClinicGroupIdPractitionerIdFacilitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerClinicGroupIdPractitionerIdFacilitiesGet$Response(params: PractitionerClinicGroupIdPractitionerIdFacilitiesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<FacilityModel>>> {
    const obs = practitionerClinicGroupIdPractitionerIdFacilitiesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerClinicGroupIdPractitionerIdFacilitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerClinicGroupIdPractitionerIdFacilitiesGet(params: PractitionerClinicGroupIdPractitionerIdFacilitiesGet$Params, context?: HttpContext): Observable<Array<FacilityModel>> {
    const resp = this.practitionerClinicGroupIdPractitionerIdFacilitiesGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<FacilityModel>>): Array<FacilityModel> => r.body)
    );
  }

  /** Path part for operation `facilitiesGet()` */
  static readonly FacilitiesGetPath = '/Facilities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesGet$Response(params?: FacilitiesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<FacilityModel>>> {
    const obs = facilitiesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilitiesGet(params?: FacilitiesGet$Params, context?: HttpContext): Observable<Array<FacilityModel>> {
    const resp = this.facilitiesGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<FacilityModel>>): Array<FacilityModel> => r.body)
    );
  }

  /** Path part for operation `practitionerLinkProtocolPost()` */
  static readonly PractitionerLinkProtocolPostPath = '/Practitioner/LinkProtocol';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerLinkProtocolPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerLinkProtocolPost$Response(params?: PractitionerLinkProtocolPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = practitionerLinkProtocolPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerLinkProtocolPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerLinkProtocolPost(params?: PractitionerLinkProtocolPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.practitionerLinkProtocolPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `practitionerUnLinkProtocolPost()` */
  static readonly PractitionerUnLinkProtocolPostPath = '/Practitioner/UnLinkProtocol';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerUnLinkProtocolPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerUnLinkProtocolPost$Response(params?: PractitionerUnLinkProtocolPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = practitionerUnLinkProtocolPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerUnLinkProtocolPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practitionerUnLinkProtocolPost(params?: PractitionerUnLinkProtocolPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.practitionerUnLinkProtocolPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `practitionerPractitionerIdClinicGroupsGet()` */
  static readonly PractitionerPractitionerIdClinicGroupsGetPath = '/Practitioner/{practitionerId}/ClinicGroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practitionerPractitionerIdClinicGroupsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerPractitionerIdClinicGroupsGet$Response(params: PractitionerPractitionerIdClinicGroupsGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<ClinicGroupDetailModel>>> {
    const obs = practitionerPractitionerIdClinicGroupsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practitionerPractitionerIdClinicGroupsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practitionerPractitionerIdClinicGroupsGet(params: PractitionerPractitionerIdClinicGroupsGet$Params, context?: HttpContext): Observable<Array<ClinicGroupDetailModel>> {
    const resp = this.practitionerPractitionerIdClinicGroupsGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<ClinicGroupDetailModel>>): Array<ClinicGroupDetailModel> => r.body)
    );
  }

}
